import { calculateOrder } from 'calculations';

export function buildReceipt(products = [], bundles = [], event, discount, seatsPicked = []) {

    // Check if we're using multi-level seat pricing
    const hasMultiLevelPricing = products.some(
        (p) => p.type === 3 && p.seatPricing && Array.isArray(p.seatPricing) && p.seatPricing.length > 0
    );

    let cart, ticketCount;

    if (hasMultiLevelPricing && seatsPicked && seatsPicked.length > 0) {
        // For multi-level pricing, build cart from selected seats
        const seatItems = seatsPicked.reduce((acc, seat) => {
            let price = 0;
            let ticketTypeLabel = seat.category.label;

            if (seat.selectedTicketType && seat.pricing?.ticketTypes) {
                const selectedType = seat.pricing.ticketTypes.find(
                    (tt) => tt.ticketType === seat.selectedTicketType
                );
                price = selectedType?.price ?? 0;
                ticketTypeLabel = selectedType?.label ?? seat.category.label;
            } else {
                price = seat.pricing?.price ?? seat.price ?? 0;
            }
            acc.push({
                name: ticketTypeLabel,
                price: price,
                qty: 1,
                paidProductCount: price > 0 ? 1 : 0,
            });
            return acc;
        }, []);

        // Include non-seat products (type 1 and 2) from the regular cart
        const nonSeatProducts = products
            .filter((p) => p.type !== 3 && p.qty > 0)
            .map((p) => ({
                name: p.name,
                price: p.price,
                qty: p.qty,
                paidProductCount: p.paidProductCount,
            }));

        cart = bundles.concat(seatItems).concat(nonSeatProducts);
        ticketCount = seatsPicked.length + bundles.reduce((p, n) => p + n.qty, 0) + nonSeatProducts.reduce((p, n) => p + n.qty, 0);
    } else {
        // Standard cart-based pricing
        cart = bundles.concat(products).map((i) => ({
            name: i.name,
            price: i.price,
            qty: i.qty,
            paidProductCount: i.paidProductCount,
        }));
        ticketCount = cart.reduce((p, n) => p + n.qty, 0);
    }

    const fees = calculateOrder(cart, products, bundles, seatsPicked, event, discount);

    const { subTotal, discountTotal, serviceFee, creditCardFee, tax, total, unifiedFee } = fees;
    const { taxName } = event.fees;

    return {
        // Return values passed in
        event,
        discount,
        // New computed values
        cart,
        ticketCount,
        subTotal,
        discountTotal,
        serviceFee,
        creditCardFee,
        tax,
        total,
        unifiedFee,
        taxName,
        discountsApplied: fees.discountsApplied,
    };
}
